import Api from '@/axios'

export default {
  getMedia (type, page) {
    return Api().get(`/pages/media/${type}?page=${page}`)
  }
}
